import { useMutation } from 'react-query';
import { getPrivateApi } from '../../../../services/api';

export function useExportNetSuiteCreditMemo() {
  return useMutation(async (creditLedgerEntryId: string) => {
    const api = getPrivateApi();

    return api.netSuiteExportCreditMemo({ netSuiteExportCreditMemoRequest: { creditLedgerEntryId } });
  });
}
